/** @format */

import React, { useRef } from 'react';
import ReactLoading from 'react-loading';

const FallbackLoading = () => {
	const ref = useRef(null);
	return (
		<div className='w-full bg-slate-100 h-screen flex justify-center items-center'>
			<ReactLoading
				type={'bubbles'}
				height={'40px'}
				width={'80px'}
				color={'#0F172A'}
				ref={ref}
			/>
		</div>
	);
};

export default FallbackLoading;
